export default "__VITE_ASSET__D5zT8v3M__"